import config from '@/services/config'
import axios from './axios_interceptors'
import {tokenExpired} from '@/auth/utils'

export default {
  getNotesInfluencerCampaign(campaign_influencer_uuid, page = 1, size_page = 5) {
    return axios.get(`${config.urlCore}/api/v3/campaign/campaign-influencer/${campaign_influencer_uuid}/notes/?page=${page}&size_page=${size_page}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
      })
      .then(response => response.data.response)
      .catch(error => {
        return error.response
      });
  },
  addCampaignInfluencerNote(campaign_influencer_uuid, note) {
    return axios.post(`${config.urlCore}/api/v3/campaign/campaign-influencer/${campaign_influencer_uuid}/notes/`,
      { note },
      {
        headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}
      }).then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired
        return error.response
      })
  },
  updateCampaignInfluencerNote(note_uuid, note) {
    return axios.put(`${config.urlCore}/api/v3/campaign/campaign-influencer-note/${note_uuid}/`,
      { note },
      {
        headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}
      }).then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired
        return error.response
      })
  },
  deleteCampaignInfluencerNote(note_uuid) {
    return axios.delete(`${config.urlCore}/api/v3/campaign/campaign-influencer-note/${note_uuid}/`,
      {
        headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}
      }).then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired
        return error.response
      })
  },
  getImageUpdatedContent(content_uuid) {
    return axios.get(`${config.urlCore}/api/v3/campaign/get-asset-content-updated/${content_uuid}/`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
      })
      .then(response => response.data.response)
      .catch(error => {
        return error.response
      });
  },
  getCampaign (campaign_uuid) {
    return axios.get(`${config.urlCore}/api/v1/campaign/${campaign_uuid}`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}
    }).then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired
        return error.response
      })
  },
  getCampaignBrief (campaign_uuid) {
    return axios.get(`${config.urlCore}/api/v1/campaign/${campaign_uuid}`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}
    }).then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired
        return error.response
      })
  },
  getCampaignInfluencers(campaign_uuid, page = 1, size_page = 100, status = 'all', params = '', query = '', order_by = '') {
    let url = `${config.urlCore}/api/v1/campaign/${campaign_uuid}/influencers/?query=${query}&page=${page}&size_page=${size_page}${params}`
    if (status !== 'all') url += `&status=${status}`
    if (order_by) url += `&order_by=${order_by}`

    return axios.get(url, {
      headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}
    }).then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired
        return error.response
      })
  },
  getCampaignManage(campaign_uuid, params = '', query = '', page = 1, size_page = 100) {
    const url = `${config.urlCore}/api/v1/campaign/${campaign_uuid}/manage/?query=${query}&page=${page}&size_page=${size_page}${params}`;

    return axios.get(url, {
      headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}
    }).then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired
        return error.response
      })
  },
  influencerAction(campaign_uuid, influencers, status) {
    const data = { influencers, status}
    return axios.post(`${config.urlCore}/api/v1/campaign/${campaign_uuid}/influencers/`,
      data,
      {
        headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}
      }).then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired
        return error.response
      })
  },
  getCampaignBrands () {
    return axios.get(`${config.urlCore}/api/v1/brands/`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}
    }).then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired
        return error.response
      })
  },
  getMessageInvitation () {
    return axios.get(`${config.urlCore}/api/v1/campaign/message/invitation/`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}
    }).then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired
        return error.response
      })
  },
  createCampaign (campaign) {
    return axios.post(`${config.urlCore}/api/v1/campaign/`,
      campaign,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired()
        return error.response
      })
  },
  addInfluncer (campaign_uuid, formdata) {
    return axios.post(`${config.urlCore}/api/v1/campaign/${campaign_uuid}/assign/`,
      formdata,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired()
        return error.response
      })
  },
  addInfluencersCampaign(campaign_uuid, influencers) {
    const data = {influencers}
    return axios.post(`${config.urlCore}/api/v3/campaign/${campaign_uuid}/massive/assign/`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`
        }
      })
      .then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired()
        return error.response.data.response
      })
  },
  addInfluncerv3 (campaign_uuid, formdata) {
    return axios.post(`${config.urlCore}/api/v3/campaign/${campaign_uuid}/assign/`,
      formdata,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired()
        return error.response
      })
  },
  getStats (campaign) {
    return axios.get(`${config.urlCore}/api/v1/campaign/${campaign}/manage/stats/`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}
    }).then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired
        return error.response
      })
  },
  getNewStats (campaign) {
    return axios.get(`${config.urlCore}/api/v3/campaign/${campaign}/manage/stats/`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}
    }).then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired
        return error.response.data.response
      })
  },
  getNewStatsDemography (campaign) {
    return axios.get(`${config.urlCore}/api/v3/campaign/${campaign}/manage/stats/demography/`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}
    }).then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired
        return error.response.data.response
      })
  },
  getNewStatsAges (campaign) {
    return axios.get(`${config.urlCore}/api/v3/campaign/${campaign}/manage/stats/ages/`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}
    }).then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired
        return error.response.data.response
      })
  },
  createCustomField(camapign_uuid, form_data) {
    return axios.post(`${config.urlCore}/api/v1/campaign/${camapign_uuid}/custom_field/`,
      form_data, {
        headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}
      }).then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired
        return error.response.data.response
      })
  },
  updateCampaignField (campaign, field, formdata) {
    return axios.post(`${config.urlCore}/api/v1/campaign/${campaign}/custom_field/${field}/`,
      formdata, {
        headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}
      }).then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired
        return error.response
      })
  },
  reorderCustomFields(campaign_pk, custom_fields) {
    return axios.post(`${config.urlCore}/api/v1/campaign/reorder/custom-fields/${campaign_pk}/`,
      {custom_fields}, {
        headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}
      }).then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired
        return error.response
      })
  },
  updateCampaign (campaign, formdata) {
    return axios.post(`${config.urlCore}/api/v1/campaign/${campaign}/update/`,
      formdata, {
        headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}
      }).then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired
        return error.response
      })
  },
  changePriceCollab(slug_campaign, data) {
    return axios.post(`${config.urlCore}/api/v3/campaign/external/change-price-collab/${slug_campaign}/`,
      data, {
        headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}
      }).then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired
        return error.response
      })
  },
  deleteCustomField(campaign_uuid, custom_field_uuid) {
    return axios.delete(`${config.urlCore}/api/v1/campaign/${campaign_uuid}/custom_field/${custom_field_uuid}/`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}
    }).then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired
        return error.response
      })
  },
  addContent(campaign_uuid, formdata) {
    return axios.post(`${config.urlCore}/api/v1/campaign/${campaign_uuid}/manage/add/`,
      formdata, {
        headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}
      }).then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired
        return error.response
      })
  },
  bulkAddContent(campaign_uuid, formdata) {
    return axios.post(`${config.urlCore}/api/v1/campaign/${campaign_uuid}/manage/bulk-add/`,
      formdata, {
        headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}
      }).then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired
        return error.response
      })
  },
  exportProposals(campaign_uuid, campaign_influencers) {
    const data = {campaign_influencers}
    return axios.post(`${config.urlCore}/api/v1/campaign/${campaign_uuid}/export/proposals/`, 
      data, {
        headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}
      }).then(response => response.data)
      .catch(error => {
        if (error.response.status === 401) tokenExpired
        return error.response
      })
  },
  exportManage(campaign_uuid) {
    return axios.get(`${config.urlCore}/api/v1/campaign/${campaign_uuid}/export/manage/`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}
    }).then(response => response.data)
      .catch(error => {
        if (error.response.status === 401) tokenExpired
        return error.response
      })
  },
  checkProcess() {
    return axios.get(`${config.urlCore}/api/v1/campaign/check/process/`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}
    }).then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired
        return error.response
      })
  },
  // uploadCsv: temporarily removed while back-end is being adapted
  // uploadCsv (campaign_uuid, formData) {
  //   return axios.post(`${config.urlCore}/api/v1/campaign/${campaign_uuid}/import/influencers/`,
  //     formData,
  //     {
  //       headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}
  //     })
  //     .then(response => response.data.response)
  //     .catch(error => {
  //       if (error.response.status === 401) tokenExpired()
  //       return error.response.data.response
  //     })
  // },
  deleteCreator (campaign_uuid, formData) {
    return axios.post(`${config.urlCore}/api/v1/campaign/${campaign_uuid}/influencers/`,
      formData,
      {
        headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}
      })
      .then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired()
        return error.response.data.response
      })
  },
  getInfluencersCampaign (campaign_uuid) {
    return axios.get(`${config.urlCore}/api/v1/campaign/${campaign_uuid}/influencers/`,
      {
        headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}
      })
      .then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired()
        return error.response.data.response
      })
  },
  createExportCampaignSummaries(campaign_uuid, influencers) {
    return axios.post(`${config.urlCore}/api/v3/campaign/export-summaries-campaign/${campaign_uuid}/`,
      {influencers},
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
      })
      .then(response => response.data.response)
      .catch(error => {
        return error.response
      });
  },
  agreementCreator(campaign_influencer_uuid, agreement) {
    const data = { campaign_influencer_uuid, agreement}
    return axios.post(`${config.urlCore}/api/v3/campaign/save-agreement-creator/`,
      data,
      {
        headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}
      }).then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired()
        return error.response
      })
  },
  getContentsManage(campaign_uuid, page = 1, size_page = 100, filters) {
    const url = `${config.urlCore}/api/v3/campaign/list-contents/${campaign_uuid}/?page=${page}&size_page=${size_page}`;
    filters
    return axios.post(url,
      filters,
      {
        headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}
      }).then(response => response.data.response)
      .catch(error => {
        if (error.response.status === 401) tokenExpired()
        return error.response
      })
  },
  getInfluencerVideos(channel_id, next_page_token = '') {
    return axios.post(
      `${config.urlCore}/api/v3/campaign/influencer-content/${channel_id}/videos/`,
      { next_page_token },
      { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
    ).then(response => ({
      videos: response.data.response.videos || [],
      nextPageToken: response.data.response.nextPageToken || '',
    })).catch(error => {
      if (error.response?.status === 401) tokenExpired();
      return { videos: [], nextPageToken: '' };
    });
  },
}

export const getExportsCampaign = (size_page = 20, page = 1, data) => {
  return axios.post(`${config.urlCore}/api/v3/campaign/export-summaries/?size_page=${size_page}&page=${page}`,
    data,
    {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
    })
    .then(response => response.data.response)
    .catch(error => {
      return error.response
    });
};